import React from 'react';
import { LinkV2, LinkV2Props, useDisclosure } from '@withjoy/joykit';
import { withWindow } from '@shared/utils/withWindow';
import { addAction } from '@shared/utils/logger';
import { ensureHttpsPrefix } from '@shared/utils/urlHelpers';
import { LinkConfirmationDialog } from '../LinkConfirmationDialog';

export const LinkWithConfirmationDialog: React.FC<LinkV2Props> = ({ href: hrefProp, onClick, children, ...restProps }) => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const href = ensureHttpsPrefix(hrefProp?.trim() || '');

  const linkProps = {
    textAlign: 'left',
    ...restProps,
    as: 'button',
    onClick: (...args) => {
      if (!href) {
        withWindow(global => {
          addAction('verifyUrl', { context: 'LinkWithConfirmationDialog', placeUrl: global.location.href });
          onClose();
        });
        return;
      }
      onClick?.(...args);
      onOpen();
    },
  } as LinkV2Props;

  return (
    <>
      <LinkV2 {...linkProps}>{children}</LinkV2>
      {href && (
        <LinkConfirmationDialog
          href={href}
          isOpen={isOpen}
          onClose={onClose}
        />
      )}
    </>
  );
};
